export default {
  error: {
    error_occured: "Ein Fehler ist aufgetreten",
    reload_page: "Seite neu laden",
    back: "Zurückgehen",
    message: {
      not_found: "Die angeforderte Seite wurde nicht gefunden!",
      unavailable: "Dienst nicht verfügbar!",
      not_authorized_title: "Zugriff verweigert",
      not_authorized: "Sie sind nicht berechtigt, auf diese Seite zuzugreifen",
      file_not_authorized: "Sie sind nicht berechtigt, eine Datei herunterzuladen",
      unauthenticated: "Sie müssen sich authentifizieren, um auf diese Seite zuzugreifen",
    },
    go_back_to_home: "Zur Startseite zurückkehren",
    support_message:
      "Bei der Operation ist ein Fehler aufgetreten. Unsere Teams arbeiten daran, das Problem zu lösen. Vielen Dank für Ihr Verständnis.",
  },
  warning: {
    title: "Achtung: ",
    login_attempts:
      "Sie haben noch {attempts} Versuche. Danach wird Ihr Zugang aus Sicherheitsgründen 5 Minuten lang gesperrt.",
    login_blocked:
      "Ihr Konto ist aufgrund mehrerer fehlgeschlagener Versuche vorübergehend gesperrt. Bitte warten Sie 5 Minuten, bevor Sie es erneut versuchen.",
  },
};
